import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// i18n side-effect import — must run before any component uses useTranslation.
import './i18n';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { initSentry } from './monitoring/sentry';
import { SentryErrorBoundary } from './monitoring/SentryErrorBoundary';

// Kick off Sentry early so any render error gets reported. The promise is
// intentionally not awaited — render can start immediately; telemetry just
// catches up once the dynamic import resolves.
void initSentry();

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Failed to find the root element");
}

const root = ReactDOM.createRoot(rootElement as HTMLElement);

root.render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </SentryErrorBoundary>
  </React.StrictMode>
);
